var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_2",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "   M112.021,14.356l268.333,105.812c31.044,12.242,49.706,44.11,45.193,77.174l-41.234,302.06",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M47.549,199.799c0,0,108.083,42.096,222.993,45.509c0,0-47.826,74.777-22.754,141.003c30.15,79.64,14.79,113.09,14.79,113.09",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M74.75,67.645l206.356,72.992c14.148,5.041,29.525,5.498,43.947,1.305l0.098-0.029c6.575-1.911,13.669-0.119,18.547,4.687v0   c7.251,7.144,7.545,18.747,0.664,26.249l-0.066,0.072c-3.389,3.695-8.108,5.893-13.118,6.109l-6.003,0.259   c-6.7,0.289-12.397,4.985-13.959,11.507l-2.383,9.945c-1.487,6.205-6.906,10.673-13.281,10.948l0,0   c-5.216,0.225-10.14-2.412-12.843-6.879l-9.33-15.418c-2.99-4.941-7.677-8.623-13.184-10.359L67.339,119.092",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M336.82,221.308l26.413-35.211c5.175-6.899,15.962-5.219,18.777,2.932c2.953,8.552,5.441,19.652,4.785,31.831   c-0.329,6.108-5.722,10.695-11.809,10.092l-12.247-1.213",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M336.82,499.401l16.35-201.552l13.332-4.341c7.409-2.412,12.722-8.937,13.582-16.682l0,0c0.611-5.502-1.103-11.008-4.728-15.191   l-0.554-0.639c-5.502-6.349-14.406-8.546-22.23-5.485l0,0c-10.008,3.915-21.22,3.306-30.745-1.67l-0.332-0.174   c-9.334-4.876-20.728,0.63-22.708,10.972v0c-0.865,4.515,0.291,9.182,3.163,12.771l14.989,18.736l-15.466,203.253",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image-2.27f6291470561f43e41cf38ef7a8647a.svg";
export { ForwardRef as ReactComponent };